import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import { getInputStyles } from "@redotech/redo-model/brand-kit/utils";
import classNames from "classnames";
import {
  RedoPhoneNumberInput,
  RedoPhoneNumberInputProps,
} from "./arbiter-components/input/redo-phone-number-input";
import {
  RedoTextInput,
  RedoTextInputProps,
} from "./arbiter-components/input/redo-text-input";
import {
  RedoTextareaInputField,
  RedoTextareaInputFieldProps,
} from "./arbiter-components/input/redo-textarea-input-field";
import * as css from "./brand-kit-text-input.module.css";

/* Memoizing this causes the signup form builder to not update the override styles */
export const BrandKitTextInput = function BrandKitTextInput({
  brandKit,
  override,
  htmlPattern,
  ...props
}: Omit<RedoTextInputProps, "style"> & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
  htmlPattern?: string;
}) {
  const style = getInputStyles(brandKit, override);
  return (
    <RedoTextInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      htmlPattern={htmlPattern}
      {...props}
    />
  );
};

export const BrandKitPhoneNumberInput = function BrandKitPhoneNumberInput({
  brandKit,
  override,
  htmlPattern,
  supportedCountryCodes,
  ...props
}: RedoPhoneNumberInputProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);

  return (
    <RedoPhoneNumberInput
      className={classNames(
        css.brandKitTextInput,
        css.brandKitPhoneNumberInput,
      )}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      htmlPattern={htmlPattern}
      supportedCountryCodes={supportedCountryCodes}
      {...props}
    />
  );
};

export const BrandKitTextAreaInput = function BrandKitTextAreaInput({
  brandKit,
  override,
  ...props
}: RedoTextareaInputFieldProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);

  return (
    <RedoTextareaInputField
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
